import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CampaignsService } from 'src/app/services/api/campaigns.service';
import { CampaignsFormComponent } from '../components/campaigns-form/campaigns-form.component';

@Component({
  selector: 'app-campaign-edit-page',
  imports: [CampaignsFormComponent],
  templateUrl: './campaigns-edit-page.component.html',
  styleUrl: './campaigns-edit-page.component.scss'
})
export class CampaignEditPageComponent {
  campaignId!: number
  campaign?: any;

  constructor(
    private route: ActivatedRoute,
    private campaignsService: CampaignsService,
  ) {
  }

  ngOnInit(): void {
    this.campaignId = Number(this.route.snapshot.paramMap.get('campaignId'));
    if (this.campaignId) {
      this.loadData(this.campaignId);
    }
  }

  loadData(campaignId: any) {
    this.campaignsService.detail(campaignId).subscribe((response: any) => {
      this.campaign = response.data?.campaign;
    });

  }
}
